var map = {
	"./about-us-banner.png": "1898",
	"./bg-video.png": "1883",
	"./course.png": "4761",
	"./culture_1.png": "ea5c",
	"./culture_2.png": "2d59",
	"./icon-left.png": "1f43",
	"./icon-right.png": "8b9e",
	"./logo-stone.png": "b8d9",
	"./map.png": "4cf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "409f";